import { Link } from 'react-router-dom';
import { categories } from '@/mocks/zh/home';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          分类浏览
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} - ${cat.description}`}
                title={`${cat.name}吃瓜视频 - ${cat.description}`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm mb-3">
                  <i className={`${cat.icon} text-white text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/70 text-center px-4">
                  {cat.description}
                </p>
                <span className="mt-3 text-xs text-white/50 bg-white/10 px-3 py-1 rounded-full">
                  {cat.count.toLocaleString()} 条内容
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}